<template>

  <v-app
    id="lex-web"
    v-bind:ui-minimized="isUiMinimized"
    :style="{ 'font-family': 'Poppins', }"
  >

  
    <!-- 富文本图片放大区域 -->
    <!-- <div
      class="imgDolg"
      v-show="imgPreview.show"
      @click.stop="imgPreview.show = false"
    >
      <i
        class="el-icon-close"
        id="imgDolgClose"
        @click.stop="imgPreview.show = false"
      ></i>
      <img @click.stop="imgPreview.show = true" :src="imgPreview.img" />
    </div> -->
    <!-- 放大demo区 -->

    <min-button
      v-bind:toolbar-color="toolbarColor"
      v-bind:is-ui-minimized="isUiMinimized"
      v-on:toggleMinimizeUi="toggleMinimizeUi"
    ></min-button>
    <!-- <toolbar-container
      
      v-bind:userName="userNameValue"
      v-bind:toolbar-title="toolbarTitle"
      v-bind:toolbar-color="toolbarColor"
      v-bind:toolbar-logo="toolbarLogo"
      v-bind:icondots-logo="icondotsLogo"
      v-bind:is-ui-minimized="isUiMinimized"
      :isTextFocus="isTextFocus"
      :token="token"
      v-on:toggleMinimizeUi="toggleMinimizeUi"
      @requestLogin="handleRequestLogin"
      @requestLogout="handleRequestLogout"
      @requestLiveChat="handleRequestLiveChat"
      @endLiveChat="handleEndLiveChat"
      transition="fade-transition"
      :style="{
        position: isTextFocus && this.isiOS ? 'relative' : 'fixed',
        display: this.isiOS ?  'none' : '',
        
    
        'padding-top':  50% - status_height + 'px'
      }"
    >
  
    </toolbar-container> -->
    <v-content v-if="!isUiMinimized">
 
      <v-container
        class="message-list-container"
        v-bind:class="`toolbar-height-${toolbarHeightClassSuffix}`"
        fluid
        pa-0
        :style="{
          top: this.isiOS ? '' : '56px',
          height: this.isiOS ? 'calc(100% - 2 * 10vw)' : 'calc(100% - 2 * 23vw)',
          marginTop: 50% - status_height + 'px'
        }"
      >     

       <!-- <div id="pic">
<a href="https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-2500.jpg" 
    data-pswp-width="1669" 
    data-pswp-height="2500" 
    target="_blank">
    <img src="https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-200.jpg" alt="" />
  </a>
  <a href="https://cdn.photoswipe.com/photoswipe-demo-images/photos/7/img-2500.jpg" 
    data-pswp-width="1875" 
    data-pswp-height="2500" 
    data-cropped="true" 
    target="_blank">
    <img src="https://cdn.photoswipe.com/photoswipe-demo-images/photos/7/img-200.jpg" alt="" />
    Cropped
  </a>
</div> -->

<!-- <div id="pic">
<a href="https://renpho-cloud.s3.amazonaws.com/renpho-lex/image/OperationCard4(1).png"
      :data-pswp-width="2500"
      :data-pswp-height="1667"
      target="_blank">
<img src="https://renpho-cloud.s3.amazonaws.com/renpho-lex/image/OperationCard4(1).png" width="250" height="48" data-index="0"/>
</a>
</div> -->
 <!-- <SimpleGallery galleryID="pic" :images="images" /> -->
       <!-- 10 23<v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular> -->

        <!-- 10 -->
        <!-- 41  <Lottie
          :options="defaultOptions"
          :height="60"
          :width="60"
          :style="{
            display:
              animate || this.$store.state.messages.length > 1 || isTextFocus
                ? 'none'
                : 'auto',
            position: 'absolute',
            left: '8vw',
            top: '6vw',
          }"
        /> -->
        <!-- <div class="textl">{{ msgs }}</div> -->
  <!-- <van-pull-refresh v-model="loadings" @refresh="onRefresh"  success-text="刷新成功" 
 :loading-icon-size="80"> -->
           <!--   :head-height="80"<p>刷新次数: {{ count }}</p> -->
     <!-- <template #pulling="props">
    <img
      class="doge"
      src="https://fastly.jsdelivr.net/npm/@vant/assets/doge.png"
      :style="{ transform: `scale(${props.distance / 80})` }"
    />
  </template> -->

  <!-- 释放提示 -->
  <!-- <template #loosing>
    <img
      class="doge"
      src="https://fastly.jsdelivr.net/npm/@vant/assets/doge.png"
    />
  </template> -->

  <!-- 加载提示 -->
  <!-- <template #loading>
    <img
      class="doge"
      src="https://fastly.jsdelivr.net/npm/@vant/assets/doge-fire.jpeg"
    />
  </template>
  <p>刷新次数: {{ count }}</p> -->
  <!-- </van-pull-refresh> -->
  
        <message-list
          v-if="!isUiMinimized"
          id="msg"
      v-bind:toolbar-logo="toolbarLogo"
      v-bind:loading-gif="LoadingGif"
          :isTextFocus="isTextFocus"
          @sendToken="send"
        >
        </message-list>  
         <!-- <van-loading size="24" >test</van-loading>
        <div :style="{display: 'flex', 'align-items': 'center'}">
        <svg class="loading" version="1.1" xmlns="http://www.w3.org/2000/svg" width='50' height='50'>
        <circle class="circle" cx="25" cy="25" r="9" fill="none" stroke-width="1"  stroke="#000"/>
        </svg><div :style="{ marginBottom: '-2vw',
     'margin-left': '-2vw'}">22</div>
         </div> -->
 
        
          <!-- </van-pull-refresh> -->
      </v-container>
      
    </v-content>

    <!-- <input-container
      ref="InputContainer"
      v-if="!isUiMinimized && !hasButtons"
      v-bind:text-input-placeholder="textInputPlaceholder"
      v-bind:initial-speech-instruction="initialSpeechInstruction"
      @endLiveChatClicked="handleEndLiveChat"
      @isTextFieldFocused="TextFieldFocused"
    ></input-container> -->
    <div v-if="isSFXOn" id="sound" aria-hidden="true" />
  </v-app>
  
</template>

<script>
/*
Copyright 2017-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/

/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */

import MinButton from "@/components/MinButton";
import ToolbarContainer from "@/components/ToolbarContainer";
import MessageList from "@/components/MessageList";
import InputContainer from "@/components/InputContainer";
import LexRuntime from "aws-sdk/clients/lexruntime";
import LexRuntimeV2 from "aws-sdk/clients/lexruntimev2";
import * as animationData from "@/assets/json/bot.json";
import Lottie from "vue-lottie/src/lottie.vue";
import request from "../utils/request";
import axios from "axios";
import CryptoJS from "crypto-js";
import { showToast } from 'vant';
// import PhotoSwipeLightbox from 'photoswipe';
// import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
// import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js'
// import 'photoswipe/style.css';


import * as AWS from "aws-sdk";
import SimpleGallery from './SimpleGallery.vue';

import {
  Config as AWSConfig,
  CognitoIdentityCredentials,
} from "aws-sdk/global";
import { PullRefresh , List } from 'vant'

export default {
  name: "lex-web",
  data() {
    return {
      images: [
        {
          largeURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-2500.jpg',
          thumbnailURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-200.jpg',
          width: 1875,
          height: 2500,
        },
        {
          largeURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-2500.jpg',
          thumbnailURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-200.jpg',
          width: 1669,
          height: 2500,
        },
        {
          largeURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-2500.jpg',
          thumbnailURL:
            'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-200.jpg',
          width: 2500,
          height: 1666,
        },
      ],
        imagesTest: ['https://renpho-cloud.s3.amazonaws.com/renpho-lex/image/OperationCard4(1).png'],
      showPic: false,
      qwe:'',
      count: 0,
      loadings: false,
      redirectUrla: null,
      status_height: null,
      onLine: true,
      fenye: null,
      test: [],
      msgs: "",
      msgsContent: "",
      token: "",
      isiOS: false,
      clientHeight: document.documentElement.clientHeight,
      isTextFocus: false,
      animate: false,
      userNameValue: "",
      toolbarHeightClassSuffix: "md",
      imgPreview: {
        img: "https://renpho-cloud.s3.amazonaws.com/renpho-lex/scale-FAQ/2.png",
        show: false,
      },
      defaultOptions: {
        animationData: animationData.default,
      },
    };
  },
  components: {
    MinButton,
    ToolbarContainer,
    MessageList,
    InputContainer,
    Lottie,
    PullRefresh,
    showToast,
    SimpleGallery
  },
  computed: {
    initialSpeechInstruction() {
      return this.$store.state.config.lex.initialSpeechInstruction;
    },
    textInputPlaceholder() {
      return this.$store.state.config.ui.textInputPlaceholder;
    },
    toolbarColor() {
      return this.$store.state.config.ui.toolbarColor;
    },
    toolbarTitle() {
      return this.$store.state.config.ui.toolbarTitle;
    },
    toolbarLogo() {
      return this.$store.state.config.ui.toolbarLogo;
    },
    LoadingGif() {
console.log('LoadingGif--', this.$store.state.config.ui.LoadingGif);
      return this.$store.state.config.ui.LoadingGif;
    },
    icondotsLogo() {
      console.log('icondotsLogo--', this.$store.state.config.ui.icondotsLogo);
      return this.$store.state.config.ui.icondotsLogo;
    },
    isSFXOn() {
      return this.$store.state.isSFXOn;
    },
    isUiMinimized() {
      return this.$store.state.isUiMinimized;
    },
    hasButtons() {
      return this.$store.state.hasButtons;
    },
    lexState() {
      return this.$store.state.lex;
    },
    isMobile() {
      const mobileResolution = 900;
      return (
        this.$vuetify.breakpoint.smAndDown &&
        "navigator" in window &&
        navigator.maxTouchPoints > 0 &&
        "screen" in window &&
        (window.screen.height < mobileResolution ||
          window.screen.width < mobileResolution)
      );
    },
  },
  watch: {
    // emit lex state on changes
    lexState() {
      this.$emit("updateLexState", this.lexState);
      this.setFocusIfEnabled();
    },
    onLine: function(newVal, oldval) {
      console.log('new--oldtop',newVal, oldval)
      if(newVal == false){
   if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }

      }
      
    }
  },

  created() {     
  
            // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };
  

    this.status_height = this.$route.query.status_height;
    this.token = this.$route.query.token;
    window.localStorage.setItem("token", this.token);
    window.localStorage.setItem("status_height", this.status_height);
    console.log(
      "this.token---",
      // window.location.href,
      this.$route.path,
      this.$route.query.token,
      this.$route.query.status_height
    );
    // override default vuetify vertical overflow on non-mobile devices
    // hide vertical scrollbars
    if (!this.isMobile) {
      document.documentElement.style.overflowY = "hidden";
    }
      
    this.initConfig()
      .then(() =>{
          console.log('this.$lexWebUi.awsConfig.credentials--', AWS.config.credentials, this.qwe)
        Promise.all([
          this.$store.dispatch(
            "initCredentials",
            this.$lexWebUi.awsConfig.credentials
          ),
          this.$store.dispatch("initRecorder"),
          this.$store.dispatch(
            "initBotAudio",
            window.Audio ? new Audio() : null
          ),
          
        ])
      }
    
      )
      .then(() => {
        // This processing block adjusts the LexRunTime client dynamically based on the
        // currently configured region and poolId. Both values by this time should be
        // available in $store.state.
        //
        // A new lexRunTimeClient is constructed targeting Lex in the identified region
        // using credentials built from the identified poolId.
        //
        // The Cognito Identity Pool should be a resource in the identified region.

        // Check for required config values (region & poolId)
        if (!this.$store.state || !this.$store.state.config) {
          return Promise.reject(new Error("no config found"));
        }
        const region = this.$store.state.config.region
          ? this.$store.state.config.region
          : this.$store.state.config.cognito.region;
        if (!region) {
          return Promise.reject(
            new Error("no region found in config or config.cognito")
          );
        }
        const poolId = this.$store.state.config.cognito.poolId;
        if (!poolId) {
          return Promise.reject(new Error("no cognito.poolId found in config"));
        }

        const AWSConfigConstructor =
          window.AWS && window.AWS.Config ? window.AWS.Config : AWSConfig;

        const CognitoConstructor =
          window.AWS && window.AWS.CognitoIdentityCredentials
            ? window.AWS.CognitoIdentityCredentials
            : CognitoIdentityCredentials;

        const LexRuntimeConstructor =
          window.AWS && window.AWS.LexRuntime
            ? window.AWS.LexRuntime
            : LexRuntime;

        const LexRuntimeConstructorV2 =
          window.AWS && window.AWS.LexRuntimeV2
            ? window.AWS.LexRuntimeV2
            : LexRuntimeV2;

        const credentials = new CognitoConstructor(
          { IdentityPoolId: poolId },
          { region: region }
        );

        const awsConfig = new AWSConfigConstructor({
          region: region,
          credentials,
        });

        this.$lexWebUi.lexRuntimeClient = new LexRuntimeConstructor(awsConfig);
        this.$lexWebUi.lexRuntimeV2Client = new LexRuntimeConstructorV2(
          awsConfig
        );
        /* eslint-disable no-console */
        console.log(
          `lexRuntimeV2Client : ${JSON.stringify(
            this.$lexWebUi.lexRuntimeV2Client
          )}`
        );

        const promises = [
          this.$store.dispatch("initMessageList"),
          // this.$store.dispatch("initMessageList2"),
          // this.$store.dispatch("initMessageList3"),
          this.$store.dispatch("initPollyClient", this.$lexWebUi.pollyClient),
          this.$store.dispatch("initLexClient", {
            v1client: this.$lexWebUi.lexRuntimeClient,
            v2client: this.$lexWebUi.lexRuntimeV2Client,
          }),
         
        ];
        console.info("CONFIG : ", this.$store.state.config);
        if (
          this.$store.state &&
          this.$store.state.config &&
          this.$store.state.config.ui.enableLiveChat
        ) {
          promises.push(this.$store.dispatch("initLiveChat"));
        }
        return Promise.all(promises);
      })
      .then(() => {
        console.log("document---", document, document.title, document.img);
        document.title = this.$store.state.config.ui.pageTitle;
        document.img = this.$store.state.config.ui.titlelogo;
        console.log("afterdocument---", document, document.title, document.img);
      })
      .then(() =>
        this.$store.state.isRunningEmbedded
          ? this.$store.dispatch("sendMessageToParentWindow", {
              event: "ready",
            })
          : Promise.resolve()
      )
      .then(() => {
        //延时初始化文本出现后，会导致程序运行到这里
        if (this.$store.state.config.ui.saveHistory === true) {
          this.$store.subscribe((mutation, state) => {
           console.log('state===', state, mutation)
          //  if(mutation.p)
            // if (this.token == 'null'|| this.token == '') {
               console.log("stoer---", );
             
            if(mutation && mutation.payload && mutation.payload.singal === undefined){
              console.log('sss')
              let   userid2 = window.localStorage.getItem('userid');
              localStorage.setItem(`store-${userid2}`, JSON.stringify(state));
             } 
            // }
          });
          this.$store.subscribe((mutation, state) => {
            // console.log("state---", state.messages[state.messages.length - 1]);
            if (mutation.type === "pushMessage") {
            console.log("state---", mutation.payload,state.messages, state.messages.length, typeof(state.messages));
            // if(state.messages.length > 10) {
            //  let test2 = mutation.payload;
            // this.test.unshift(test2);
            // console.log('test2--', test2, this.test) 
            // }
           const result = state.messages.filter(item => item.id == state.messages.length -  1);

           console.log('---',result);    
            // if(state.messages.length > 10) {
            //   let test2 = state.messages;
            //   this.fenye = test2.shift(10);
            //   // let connect = test.join(test)
            //   console.log('test---', this.fenye,connect)
            // }

              // let test = this.encrypt({
              //   content: state.messages,
              //   timeStamp: new Date().getTime(),
              //   timeZone: window.localStorage.getItem("timeZone"),
              // });
              // sessionStorage.setItem("store", JSON.stringify(state));
              // let that = this;
              // // console.log('查找current---',  value, value1, typeof(value1))
              // axios
              //   .post(
              //     "http://renpho.net:7009/RenphoHealth/robot/save",
              //    {
              //   content: state.messages,
              //   timeStamp: new Date().getTime(),
              //   timeZone: window.localStorage.getItem("timeZone"),
              // },
              //     {
              //       headers: {
              //         token:
              //          // "eyJUeXBlIjoiSnd0IiwidHlwIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJleHAiOjE2NjcwMjYwODcsImlhdCI6MTY2NDQzNDA4NywidXNlcklkIjoyNDcyMTQyOTU5MDQ3Mzg3OTA4fQ.lHznijryQmuYM-blVD9bYfKjgYjXBx2-LoVK5Zp7ph8",

              //           that.token
              //       },
              //     }
              //   )
              //   .then(function (response) {
              //     // that.devices = response.data;
              //     console.log(response);
              //     console.log("添加成功---", response);
              //   })
              //   .catch(function (error) {
              //     console.log("err", error);
              //   });
            }
          });
        }
      })
      .then(() => {
        console.info(
          "successfully initialized lex web ui version: ",
          this.$store.state.version
        );

        // after slight delay, send in initial utterance if it is defined.
        // waiting for credentials to settle down a bit.
        // setTimeout(() => this.$store.dispatch("sendInitialUtterance"), 500);
      })
      .catch((error) => {
        console.error(
          "could not initialize application while mounting:",
          error
        );
      });

    //  console.log('state---', state.messages)
    if (this.token != 'null') {
      let that = this;
      let test = {
                "full":true,"pageNum":1,"pageSize":10
              };
      axios
        .post(
          " https://cloud.renpho.com/RenphoHealth/robot/selectByUserId",
          // "http://renpho.net:7009/RenphoHealth/robot/selectByUserId",
          {
              "full":true,"pageNum":1,"pageSize":10
            },
          
          {
            headers: {
              token:
              that.token
            },
          
          }
        )
        .then(function (response) {
          // let that = this;
          let msgs = response.data.data;
          // this.$store.state.messages = this.msgs;
          //   $store.subscribe((mutation, state) => {
          //   sessionStorage.setItem("store", JSON.stringify(response));
          // });
          that.msgs = msgs;
          // let test = JSON.parse(that.msgs);
          // console.log(response);
          // console.log("查找成功---",that.msgs, that.$store.state.messages);
          console.log('nsgs!!!!!', that.msg, document.getElementsByClassName('btn__content')[0]);
          localStorage.setItem("historyText", JSON.stringify(that.msgs));

          //   that.$store.state.messages = that.msgs.map(message => {
          //   console.log('reloadMessages---',message)
          //   return Object.assign({}, message, {

          //     date: new Date(message.date)
          //   });

          // });
          console.log("reloadMessages---", that.$store.state.messages);
        })
        .catch(function (error) {
          console.log("查找失败---", error);
        });
    }
  },
  beforeDestroy() {
    // localStorage.removeItem('Name');
    window.removeEventListener("online", this.update, false);
    window.removeEventListener("offline", this.update, false);
    window.onscroll = null;
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
    window.removeEventListener("touchmove", () => {
      this.animate = true;
    });
  },
  beforeMount(){

    console.log('beforeMount--')
    setTimeout(()=>{
 this.login()
    },1000)
   
  },
  beforeDestroy() {

  },
  // unmounted() {
  //   if (this.lightbox) {
  //     this.lightbox.destroy();
  //     this.lightbox = null;
  //   }
  // },
  
  mounted() {
    console.log('777---')
    // setTimeout(() => {
      
    // }, 1000);
    //  this.$store.dispatch("postTextMessage", {type:'bot', text: 'hello'})
       // 退出当前页面执行
// window.onunload = function(e){ // ios 不支持 window.onbeforeunload()
//   // 将退出时间存于localstorage中
//   localStorage.setItem('leaveTime', new Date().getTime());
// }
// context.commit('setIsLexProcessing', true);

      
      // setTimeout(() => {
        
     
       

        // context.commit('setIsLexProcessing', false);

        // this.$store.commit('pushMessage', {
        //   type: 'bot',
        //   text: 'hello',
        // });
        // context.commit('setIsLexProcessing', true);
      // }, 1000);


          // this.$store.dispatch("initMessageList2"),
  
    // console.log('777---',document.getElementsByClassName("viewer-canvas")[0].getElementsByTagName("img")[0].src)
//  const lightbox = new PhotoSwipeLightbox({
//     gallery: '#pic',
//     children: 'a',
//      pswpModule: PhotoSwipe,
//   });

//   lightbox.init();
    // console.log('lightbox---', lightbox)  

       console.log(
      "created---",
      window.location.href,
      this.$route,
      this.$route.path,
      this.$route.query.token,
      this.$route.query.status_height,
      this.$route.query.version,
      this.$route.query.flag
    ); 
    // const params = GetUrlParam()
         //原生版本号
      let version = this.$route.query.version;  
        //  console.log('this.$route.query.count-', )
      if( version == undefined ){
        version = '5.1.0';
      }    
      // if (version) {
         let that = this;
        axios
        .post(
          ` https://cloud.renpho.com/openApi/getMachinePath/${version}` ,
         // ` http://renpho.net:7009/openApi/getMachinePath/${version}` ,
          // `https://cloud.renpho.com/snapshot-openApi/getMachinePath/${version}`
          // { encryptData: test },
          // {
          //   headers: {
          //     token:
          //     that.token
          //   },
          // }
        )
        .then(function (response) {

          console.log('response--', response)
          let url = document.location.toString();
          let arrObj = url.split("?");
          
          let paramsRedict = that.$route.fullPath;
          let path = response.data.data.path;
          console.log("axios---", that.$route, version, path, paramsRedict);
      
            console.log('versionyou--')
            let redirectUrl;
            // let redirectUrl = `http://192.168.9.252:106${path}#` + paramsRedict ;
            if( version == '5.1.0'){
               redirectUrl = path + '/#' + paramsRedict;
            }else{
               redirectUrl = path + '/#' + paramsRedict + '&flag=1';
            }
            
            window.location.replace(redirectUrl);
            console.log('redirectUrl--', redirectUrl)
            
        })
        .catch(function (error) {
          console.log("axios error---", error);
        });
      // alert("Hello! I am an alert box!");
    console.log('!!!!--', document.getElementsByClassName('btn__content')[0])
    // setTimeout(() => {
          //  if (  window.localStorage.getItem('redirectUrl') == window.location.href) 
          // console.log('hideLoading---', window.localStorage.getItem('redirectUrl') , window.location.href)

    const u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端   
  //  }
    // },100)
      window.addEventListener("online", this.update, false), // 网络由异常到正常时触发
      window.addEventListener("offline", this.update, false); //网络由正常到异常时触发
    // that.msgsContent = that.msgs;
    this.originalHeight = window.innerHeight;
    console.log("this.===", document.documentElement.clientHeight, this.isiOS);
    if (!this.$store.state.isRunningEmbedded) {
      this.$store.dispatch("sendMessageToParentWindow", {
        event: "requestTokens",
      });
      this.setFocusIfEnabled();
    }
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("touchmove", () => {
      this.animate = true;
      // console.log("2222",  event.changedTouches[0].pageY);
    });
      
  },

  methods: {

      login() {
        let AmazonCognitoIdentity = require("amazon-cognito-identity-js");
      // var cognitoUser = userPool.getCurrentUser();

      let authenticationData = {
        Username: "lexuser",
        Password: "gPKs2eT#6zn",
      };
      let authenticationDetails =
        new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      let poolData = {
        UserPoolId: "us-east-1_f4Aymseho", // Your user pool id here
        ClientId: "3iu9re39amkm67ma6svoj7q4vd", // Your client id here
      };
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      let userData = {
        Username: "lexuser",
        Pool: userPool,
      };
      let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
          let accessToken = result.getAccessToken().getJwtToken();
          console.log("onSuccess---", accessToken);
          //POTENTIAL: Region needs to be set if not already set previously elsewhere.
          AWS.config.region = "us-east-1";

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: "us-east-1:2fca637a-e90c-443e-b34c-a5cec2ffca30", // your identity pool id here
            Logins: {
              // Change the key below according to the specific region your user pool is in.
              "cognito-idp.us-east-1.amazonaws.com/us-east-1_f4Aymseho": result
                .getIdToken()
                .getJwtToken(),
            },
          });

          //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
          // AWS.config.credentials.refresh((error) => {
          //   if (error) {
          //     console.error("11---", error);
          //   } else {
          //     // Instantiate aws sdk service objects now that the credentials have been updated.
          //     // example: var s3 = new AWS.S3();
          //     let that = this;
          //     that.qwe = AWS.config.credentials;
          //     console.log("Successfully logged!", AWS.config.credentials);
          //   }
          // });
            // console.log('this.$lexWebUi.awsConfig.credentials--', AWS.config.credentials)
        },

        // onFailure: function (err) {
        //   alert(err.message || JSON.stringify(err));
        // },
      });
      },
          // 获取全部参数  把url所有参数存进一个对象
      GetUrlParam() {
        let url = document.location.toString();
        let arrObj = url.split("?");
        console.log('arrObj---', arrObj)
        let params = Object.create(null) 
        if (arrObj.length > 1) {
            arrObj = arrObj[1].split("&");
            arrObj.forEach(item => {
                item = item.split("=");
                console.log('item---', item)
                params[item[0]] = item[1]
            })
        }
        return params;
      },
        update(res) {
      console.log(res);
      this.onLine = res.type === "online";
      if (this.onLine) {
        console.log("网络正常-lex--", this.$route.query.token);
      } else if (this.$route.query.token !== "null") {
        console.log("网络异常--lex-", this.$route.query.token);
      }
    },
    send(data) {
      this.token = data;
      console.log("sedn!===", typeof this.token, "---", typeof data);
    },
    //加密
    encrypt(data) {
      // 十六位十六进制数作为密钥
      const SECRET_KEY = CryptoJS.enc.Utf8.parse("ts*3iuer$g9we8mi");
      // 十六位十六进制数作为密钥偏移量
      const SECRET_IV = CryptoJS.enc.Utf8.parse("");
      if (typeof data === "object") {
        try {
          // eslint-disable-next-line no-param-reassign
          data = JSON.stringify(data);
        } catch (error) {
          console.log("encrypt error:", error);
        }
      }
      const dataHex = CryptoJS.enc.Utf8.parse(data);
      const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    //解密
    decrypt(data) {
      // 十六位十六进制数作为密钥
      const SECRET_KEY = CryptoJS.enc.Utf8.parse("ts*3iuer$g9we8mi");
      // 十六位十六进制数作为密钥偏移量
      const SECRET_IV = CryptoJS.enc.Utf8.parse("");
      const decrypt = CryptoJS.AES.decrypt(data, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      // console.log("查找decryptedStr---", data, decryptedStr);
      // this.$store.state.messages = decryptedStr;
      console.log("查找decryptedStr--222-", decryptedStr.toString());
      // this.$store.subscribe((mutation, state) => {
      // sessionStorage.setItem("historyText", JSON.stringify(decryptedStr));
      // });

      return decryptedStr.toString();
    },

    showImg(e) {
      // console.log(e.target)
      if (e.target.tagName == "IMG") {
        this.imgPreview.img = e.target.src;
        this.imgPreview.show = true;
      }
    },
    onResize() {
      const { innerWidth } = window;
      this.setToolbarHeigthClassSuffix(innerWidth);
    },
    setToolbarHeigthClassSuffix(innerWidth) {
      // Vuetify toolbar changes height based on innerWidth

      // when running embedded the toolbar is fixed to dense
      if (this.$store.state.isRunningEmbedded) {
        this.toolbarHeightClassSuffix = "md";
        return;
      }

      // in full screen the toolbar changes size
      if (innerWidth < 640) {
        this.toolbarHeightClassSuffix = "sm";
      } else if (innerWidth > 640 && innerWidth < 960) {
        this.toolbarHeightClassSuffix = "md";
      } else {
        this.toolbarHeightClassSuffix = "lg";
      }
    },
    toggleMinimizeUi() {
      return this.$store.dispatch("toggleIsUiMinimized");
    },
    loginConfirmed(evt) {
      this.$store.commit("setIsLoggedIn", true);
      if (evt.detail && evt.detail.data) {
        this.$store.commit("setTokens", evt.detail.data);
      } else if (evt.data && evt.data.data) {
        this.$store.commit("setTokens", evt.data.data);
      }
    },
    logoutConfirmed() {
      this.$store.commit("setIsLoggedIn", false);
      this.$store.commit("setTokens", {
        idtokenjwt: "",
        accesstokenjwt: "",
        refreshtoken: "",
      });
    },
    handleRequestLogin() {
      console.info("request login");
      if (this.$store.state.isRunningEmbedded) {
        this.$store.dispatch("sendMessageToParentWindow", {
          event: "requestLogin",
        });
      } else {
        this.$store.dispatch("sendMessageToParentWindow", {
          event: "requestLogin",
        });
      }
    },
    handleRequestLogout() {
      console.info("request logout");
      if (this.$store.state.isRunningEmbedded) {
        this.$store.dispatch("sendMessageToParentWindow", {
          event: "requestLogout",
        });
      } else {
        this.$store.dispatch("sendMessageToParentWindow", {
          event: "requestLogout",
        });
      }
    },
    handleRequestLiveChat() {
      console.info("handleRequestLiveChat");
      this.$store.dispatch("requestLiveChat");
    },
    handleEndLiveChat() {
      console.info("LexWeb: handleEndLiveChat");
      this.$store.dispatch("requestLiveChatEnd");
    },
    TextFieldFocused(data) {
      this.isTextFocus = data;
      if (this.isTextFocus) {
        // console.log('')
        // window.scrollTo(345,0)
        const element = document.getElementById("negativeText");
        console.log("el---", element);
        element.scrollIntoView(true);
      }
      console.log("this.isTextFocus", this.isTextFocus);
    },
    // messages from parent
    messageHandler(evt) {
      const messageType = this.$store.state.config.ui.hideButtonMessageBubble
        ? "button"
        : "human";
      // security check
      if (evt.origin !== this.$store.state.config.ui.parentOrigin) {
        console.warn("ignoring event - invalid origin:", evt.origin);
        return;
      }
      if (!evt.ports || !Array.isArray(evt.ports) || !evt.ports.length) {
        console.warn("postMessage not sent over MessageChannel", evt);
        return;
      }
      switch (evt.data.event) {
        case "ping":
          console.info("pong - ping received from parent");
          evt.ports[0].postMessage({
            event: "resolve",
            type: evt.data.event,
          });
          this.setFocusIfEnabled();
          break;
        // received when the parent page has loaded the iframe
        case "parentReady":
          evt.ports[0].postMessage({ event: "resolve", type: evt.data.event });
          break;
        case "toggleMinimizeUi":
          this.$store.dispatch("toggleIsUiMinimized").then(() =>
            evt.ports[0].postMessage({
              event: "resolve",
              type: evt.data.event,
            })
          );
          break;
        case "postText":
          if (!evt.data.message) {
            evt.ports[0].postMessage({
              event: "reject",
              type: evt.data.event,
              error: "missing message field",
            });
            return;
          }
          this.$store
            .dispatch("postTextMessage", {
              type: evt.data.messageType ? evt.data.messageType : messageType,
              text: evt.data.message,
            })
            .then(() =>
              evt.ports[0].postMessage({
                event: "resolve",
                type: evt.data.event,
              })
            );
          break;
        case "deleteSession":
          this.$store.dispatch("deleteSession").then(() =>
            evt.ports[0].postMessage({
              event: "resolve",
              type: evt.data.event,
            })
          );
          break;
        case "startNewSession":
          this.$store.dispatch("startNewSession").then(() =>
            evt.ports[0].postMessage({
              event: "resolve",
              type: evt.data.event,
            })
          );
          break;
        case "setSessionAttribute":
          console.log(`From LexWeb: ${JSON.stringify(evt.data, null, 2)}`);
          this.$store
            .dispatch("setSessionAttribute", {
              key: evt.data.key,
              value: evt.data.value,
            })
            .then(() =>
              evt.ports[0].postMessage({
                event: "resolve",
                type: evt.data.event,
              })
            );
          break;
        case "confirmLogin":
          this.loginConfirmed(evt);
          this.userNameValue = this.userName();
          break;
        case "confirmLogout":
          this.logoutConfirmed();
          break;
        default:
          console.warn("unknown message in messageHandler", evt);
          break;
      }
    },
    componentMessageHandler(evt) {
      switch (evt.detail.event) {
        case "confirmLogin":
          this.loginConfirmed(evt);
          this.userNameValue = this.userName();
          break;
        case "confirmLogout":
          this.logoutConfirmed();
          break;
        case "ping":
          this.$store.dispatch("sendMessageToParentWindow", { event: "pong" });
          break;
        case "postText":
          this.$store.dispatch("postTextMessage", {
            type: "human",
            text: evt.detail.message,
          });
          break;
        case "replaceCreds":
          this.$store.dispatch("initCredentials", evt.detail.creds);
          break;
        default:
          console.warn("unknown message in componentMessageHandler", evt);
          break;
      }
    },
    userName() {
      return this.$store.getters.username();
    },
    logRunningMode() {
      if (!this.$store.state.isRunningEmbedded) {
        console.info("running in standalone mode");
        return;
      }

      console.info(
        "running in embedded mode from URL: ",
        document.location.href
      );
      console.info("referrer (possible parent) URL: ", document.referrer);
      console.info(
        "config parentOrigin:",
        this.$store.state.config.ui.parentOrigin
      );
      if (
        !document.referrer.startsWith(this.$store.state.config.ui.parentOrigin)
      ) {
        console.warn(
          "referrer origin: [%s] does not match configured parent origin: [%s]",
          document.referrer,
          this.$store.state.config.ui.parentOrigin
        );
      }
    },
    initConfig() {
      if (this.$store.state.config.urlQueryParams.lexWebUiEmbed !== "true") {
        document.addEventListener(
          "lexwebuicomponent",
          this.componentMessageHandler,
          false
        );
        this.$store.commit("setIsRunningEmbedded", false);
        this.$store.commit("setAwsCredsProvider", "cognito");
      } else {
        window.addEventListener("message", this.messageHandler, false);
        this.$store.commit("setIsRunningEmbedded", true);
        this.$store.commit("setAwsCredsProvider", "parentWindow");
      }

      // get config
      return (
        this.$store
          .dispatch("initConfig", this.$lexWebUi.config)
          .then(() => this.$store.dispatch("getConfigFromParent"))
          // avoid merging an empty config
          .then((config) =>
            Object.keys(config).length
              ? this.$store.dispatch("initConfig", config)
              : Promise.resolve()
          )
          .then(() => {
            this.setFocusIfEnabled();
            this.logRunningMode();
          })
      );
    },
    setFocusIfEnabled() {
      if (this.$store.state.config.ui.directFocusToBotInput) {
        this.$refs.InputContainer.setInputTextFieldFocus();
      }
    },
  },
};
</script>

<style>
/*
The Vuetify toolbar height is based on screen width breakpoints
The toolbar can be 48px, 56px and 64px.
It is fixed to 48px when using 'dense'

The message list is placed between the toolbar at the top and input
container on the bottom. Both the toolbar and the input-container
dynamically change height based on width breakpoints.
So we duplicate the height and substract it from the total height
of the message list to make it fit between the toolbar and input container

NOTE: not using var() for different heights due to IE11 compatibility
*/

/* #lex-web{
  background-color: red;
} */

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-Light.ttf");
}

::-webkit-scrollbar {
  display: none;
}

.message-list-container {
  position: fixed;
}
.message-list-container.toolbar-height-sm {
  top: 0px;
  /* 56px */
  height: calc(100% - 2 * 66px);
  /* 66  35*/
  background-color: #fafafa;
  border-radius: 24px;
}
/* yes, the height is smaller in mid sizes */
.message-list-container.toolbar-height-md {
  top: 48px;
  height: calc(100% - 2 * 48px);
  /* 48 */
}
.message-list-container.toolbar-height-lg {
  top: 64px;
  height: calc(100% - 2 * 64px);
}
#lex-web .imgDolg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  background-color: rgba(140, 134, 134, 0.6);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
#lex-web .imgDolg #imgDolgClose {
  position: fixed;
  top: 35px;
  cursor: pointer;
  right: 7%;
  font-size: 50px;
  color: white;
}
#lex-web .imgDolg img {
  width: 80%;
}

.textl {
  background: red;
}

/deep/.selector::-webkit-scrollbar {
  display: none;
}

#lex-web[ui-minimized] {
  /* make background transparent when running minimized so only
  the button is shown */
  background: transparent;
}

/deep/.toolbar__content {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}


</style>
